import { BusHour } from "./BusTimes";

export const BUS_TIMES_WEEKDAYS: BusHour[] = [
  {
    hour: 0,
    minute: 5,
  },
  {
    hour: 0,
    minute: 20,
  },
  {
    hour: 0,
    minute: 35,
  },
  {
    hour: 5,
    minute: 9,
  },
  {
    hour: 5,
    minute: 25,
  },
  {
    hour: 5,
    minute: 40,
  },
  {
    hour: 5,
    minute: 56,
  },
  {
    hour: 6,
    minute: 3,
  },
  {
    hour: 6,
    minute: 9,
  },
  {
    hour: 6,
    minute: 17,
  },
  {
    hour: 6,
    minute: 24,
  },
  {
    hour: 6,
    minute: 32,
  },
  {
    hour: 6,
    minute: 39,
  },
  {
    hour: 6,
    minute: 47,
  },
  {
    hour: 6,
    minute: 54,
  },
  {
    hour: 7,
    minute: 2,
  },
  {
    hour: 7,
    minute: 9,
  },
  {
    hour: 7,
    minute: 17,
  },
  {
    hour: 7,
    minute: 24,
  },
  {
    hour: 7,
    minute: 32,
  },
  {
    hour: 7,
    minute: 39,
  },
  {
    hour: 7,
    minute: 47,
  },
  {
    hour: 7,
    minute: 54,
  },
  {
    hour: 8,
    minute: 2,
  },
  {
    hour: 8,
    minute: 9,
  },
  {
    hour: 8,
    minute: 17,
  },
  {
    hour: 8,
    minute: 24,
  },
  {
    hour: 8,
    minute: 32,
  },
  {
    hour: 8,
    minute: 39,
  },
  {
    hour: 8,
    minute: 47,
  },
  {
    hour: 8,
    minute: 54,
  },
  {
    hour: 9,
    minute: 2,
  },
  {
    hour: 9,
    minute: 9,
  },
  {
    hour: 9,
    minute: 17,
  },
  {
    hour: 9,
    minute: 24,
  },
  {
    hour: 9,
    minute: 32,
  },
  {
    hour: 9,
    minute: 39,
  },
  {
    hour: 9,
    minute: 47,
  },
  {
    hour: 9,
    minute: 54,
  },
  {
    hour: 10,
    minute: 2,
  },
  {
    hour: 10,
    minute: 9,
  },
  {
    hour: 10,
    minute: 17,
  },
  {
    hour: 10,
    minute: 24,
  },
  {
    hour: 10,
    minute: 32,
  },
  {
    hour: 10,
    minute: 39,
  },
  {
    hour: 10,
    minute: 47,
  },
  {
    hour: 10,
    minute: 54,
  },
  {
    hour: 11,
    minute: 2,
  },
  {
    hour: 11,
    minute: 9,
  },
  {
    hour: 11,
    minute: 16,
  },
  {
    hour: 11,
    minute: 24,
  },
  {
    hour: 11,
    minute: 31,
  },
  {
    hour: 11,
    minute: 39,
  },
  {
    hour: 11,
    minute: 46,
  },
  {
    hour: 11,
    minute: 54,
  },
  {
    hour: 12,
    minute: 1,
  },
  {
    hour: 12,
    minute: 9,
  },
  {
    hour: 12,
    minute: 16,
  },
  {
    hour: 12,
    minute: 24,
  },
  {
    hour: 12,
    minute: 31,
  },
  {
    hour: 12,
    minute: 39,
  },
  {
    hour: 12,
    minute: 46,
  },
  {
    hour: 12,
    minute: 54,
  },
  {
    hour: 13,
    minute: 1,
  },
  {
    hour: 13,
    minute: 9,
  },
  {
    hour: 13,
    minute: 16,
  },
  {
    hour: 13,
    minute: 24,
  },
  {
    hour: 13,
    minute: 31,
  },
  {
    hour: 13,
    minute: 39,
  },
  {
    hour: 13,
    minute: 46,
  },
  {
    hour: 13,
    minute: 54,
  },
  {
    hour: 14,
    minute: 1,
  },
  {
    hour: 14,
    minute: 9,
  },
  {
    hour: 14,
    minute: 16,
  },
  {
    hour: 14,
    minute: 24,
  },
  {
    hour: 14,
    minute: 31,
  },
  {
    hour: 14,
    minute: 39,
  },
  {
    hour: 14,
    minute: 46,
  },
  {
    hour: 14,
    minute: 54,
  },
  {
    hour: 15,
    minute: 1,
  },
  {
    hour: 15,
    minute: 9,
  },
  {
    hour: 15,
    minute: 16,
  },
  {
    hour: 15,
    minute: 24,
  },
  {
    hour: 15,
    minute: 31,
  },
  {
    hour: 15,
    minute: 39,
  },
  {
    hour: 15,
    minute: 46,
  },
  {
    hour: 15,
    minute: 54,
  },
  {
    hour: 16,
    minute: 1,
  },
  {
    hour: 16,
    minute: 9,
  },
  {
    hour: 16,
    minute: 16,
  },
  {
    hour: 16,
    minute: 24,
  },
  {
    hour: 16,
    minute: 31,
  },
  {
    hour: 16,
    minute: 39,
  },
  {
    hour: 16,
    minute: 46,
  },
  {
    hour: 16,
    minute: 54,
  },
  {
    hour: 17,
    minute: 1,
  },
  {
    hour: 17,
    minute: 9,
  },
  {
    hour: 17,
    minute: 16,
  },
  {
    hour: 17,
    minute: 24,
  },
  {
    hour: 17,
    minute: 31,
  },
  {
    hour: 17,
    minute: 39,
  },
  {
    hour: 17,
    minute: 46,
  },
  {
    hour: 17,
    minute: 54,
  },
  {
    hour: 18,
    minute: 1,
  },
  {
    hour: 18,
    minute: 9,
  },
  {
    hour: 18,
    minute: 16,
  },
  {
    hour: 18,
    minute: 24,
  },
  {
    hour: 18,
    minute: 31,
  },
  {
    hour: 18,
    minute: 39,
  },
  {
    hour: 18,
    minute: 46,
  },
  {
    hour: 18,
    minute: 54,
  },
  {
    hour: 19,
    minute: 1,
  },
  {
    hour: 19,
    minute: 10,
  },
  {
    hour: 19,
    minute: 18,
  },
  {
    hour: 19,
    minute: 25,
  },
  {
    hour: 19,
    minute: 33,
  },
  {
    hour: 19,
    minute: 40,
  },
  {
    hour: 19,
    minute: 48,
  },
  {
    hour: 19,
    minute: 55,
  },
  {
    hour: 20,
    minute: 3,
  },
  {
    hour: 20,
    minute: 10,
  },
  {
    hour: 20,
    minute: 18,
  },
  {
    hour: 20,
    minute: 25,
  },
  {
    hour: 20,
    minute: 33,
  },
  {
    hour: 20,
    minute: 40,
  },
  {
    hour: 20,
    minute: 48,
  },
  {
    hour: 20,
    minute: 54,
  },
  {
    hour: 21,
    minute: 0,
  },
  {
    hour: 21,
    minute: 5,
  },
  {
    hour: 21,
    minute: 12,
  },
  {
    hour: 21,
    minute: 20,
  },
  {
    hour: 21,
    minute: 35,
  },
  {
    hour: 21,
    minute: 50,
  },
  {
    hour: 22,
    minute: 5,
  },
  {
    hour: 22,
    minute: 20,
  },
  {
    hour: 22,
    minute: 35,
  },
  {
    hour: 22,
    minute: 50,
  },
  {
    hour: 23,
    minute: 5,
  },
  {
    hour: 23,
    minute: 20,
  },
  {
    hour: 23,
    minute: 35,
  },
  {
    hour: 23,
    minute: 50,
  },
];
